export default class KitFitError extends Error {
	constructor(message, type, ...details) {
		super(message)
		this.type = type
		if (details.length) {
			this.details = details
		}
	}
}



// WEBPACK FOOTER //
// ./src/utilities/Errors/KitFitError.js